
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kPKkS", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");


var $jtuBN = parcelRequire("jtuBN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7boqA = parcelRequire("7boqA");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $6mKj3 = parcelRequire("6mKj3");


var $luv00 = parcelRequire("luv00");


var $isEtk = parcelRequire("isEtk");


var $5Abqh = parcelRequire("5Abqh");


var $jMyy4 = parcelRequire("jMyy4");


var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $c992d301b5eec450$export$e03be33cf6ebb3ea = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY)
});



var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");

/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $6627c994dbd6ecf6$export$5e3c7f13be5cbe17 = /*#__PURE__*/ function(RecommendedPagesSpaceBehavior) {
    RecommendedPagesSpaceBehavior["HIDDEN"] = "HIDDEN";
    RecommendedPagesSpaceBehavior["SHOWN"] = "SHOWN";
    return RecommendedPagesSpaceBehavior;
}({});



var $ihn35 = parcelRequire("ihn35");








var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $cO1el = parcelRequire("cO1el");


var $1qfLF = parcelRequire("1qfLF");


var $2AytZ = parcelRequire("2AytZ");


var $ghftu = parcelRequire("ghftu");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");





var $fgRQY = parcelRequire("fgRQY");


var $1d2ww = parcelRequire("1d2ww");


var $kvJHJ = parcelRequire("kvJHJ");

















var $fb3kw = parcelRequire("fb3kw");


var $9EtP6 = parcelRequire("9EtP6");





var $60KP5 = parcelRequire("60KP5");


var $6sytf = parcelRequire("6sytf");


var $bQm3c = parcelRequire("bQm3c");





var $6oZiN = parcelRequire("6oZiN");

const $c9b58423be6b0f98$export$a50d500033c15d61 = (t0)=>{
    const $ = (0, $frIzR.c)(61);
    const { closeSurvey: closeSurvey, entityId: entityId, recIds: recIds, sources: sources, spaceKey: spaceKey } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [completed, setCompleted] = (0, $42omo.useState)(false);
    const [dismiss, setDismiss] = (0, $42omo.useState)(false);
    const secondQuestion = (0, $42omo.useRef)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    let t2;
    if ($[0] !== closeSurvey || $[1] !== dismiss) {
        t1 = ()=>{
            if (dismiss) closeSurvey();
        };
        t2 = [
            dismiss,
            closeSurvey
        ];
        $[0] = closeSurvey;
        $[1] = dismiss;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage((0, $6oZiN.i18n).feedbackSecondFollowup);
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.FeedbackFormQuestion), null, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (t6)=>{
            const { fieldProps: fieldProps } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
                ...fieldProps,
                onChange: (event)=>{
                    secondQuestion.current = event.target.value;
                },
                value: secondQuestion.current,
                maxHeight: "256px",
                rows: 3
            });
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "feedBackTextTwo",
            label: t4
        }, t5);
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    const secondFeedback = t6;
    let t7;
    if ($[11] !== createAnalyticsEvent || $[12] !== entityId || $[13] !== recIds || $[14] !== sources || $[15] !== spaceKey || $[16] !== userId) {
        t7 = (t8)=>{
            const { reaction: reaction, feedback: feedback, submitted: submitted, dismissed: dismissed } = t8;
            if (dismissed) setDismiss(true);
            else if (submitted) {
                if (spaceKey) createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "submitted",
                        actionSubject: "survey",
                        actionSubjectId: "endOfPageRecsFeedbackForm",
                        source: "endOfPageSpaceSettings",
                        attributes: {
                            rating: reaction.value,
                            questionOne: feedback,
                            userId: userId
                        },
                        objectId: spaceKey
                    }
                }).fire();
                else createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "submitted",
                        actionSubject: "survey",
                        actionSubjectId: "endOfPageRecsFeedbackForm",
                        source: "endOfPageRecsScreen",
                        attributes: {
                            rating: reaction.value,
                            questionOne: feedback,
                            questionTwo: secondQuestion.current,
                            recommendedIds: recIds,
                            sources: sources,
                            userId: userId
                        },
                        objectId: entityId
                    }
                }).fire();
                setCompleted(true);
            }
        };
        $[11] = createAnalyticsEvent;
        $[12] = entityId;
        $[13] = recIds;
        $[14] = sources;
        $[15] = spaceKey;
        $[16] = userId;
        $[17] = t7;
    } else t7 = $[17];
    const handleFormData = t7;
    let t8;
    if ($[18] !== intl) {
        t8 = intl.formatMessage((0, $6oZiN.i18n).terrible);
        $[18] = intl;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== intl) {
        t9 = intl.formatMessage((0, $6oZiN.i18n).bad);
        $[20] = intl;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== intl) {
        t10 = intl.formatMessage((0, $6oZiN.i18n).okay);
        $[22] = intl;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== intl) {
        t11 = intl.formatMessage((0, $6oZiN.i18n).good);
        $[24] = intl;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== intl) {
        t12 = intl.formatMessage((0, $6oZiN.i18n).great);
        $[26] = intl;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12 || $[31] !== t8 || $[32] !== t9) {
        t13 = [
            t8,
            t9,
            t10,
            t11,
            t12
        ];
        $[28] = t10;
        $[29] = t11;
        $[30] = t12;
        $[31] = t8;
        $[32] = t9;
        $[33] = t13;
    } else t13 = $[33];
    const reactions = t13;
    let t14;
    if ($[34] !== intl || $[35] !== reactions) {
        t14 = reactions.map(()=>intl.formatMessage((0, $6oZiN.i18n).feedbackFollowup));
        $[34] = intl;
        $[35] = reactions;
        $[36] = t14;
    } else t14 = $[36];
    const questions = t14;
    let t15;
    if ($[37] !== intl) {
        t15 = intl.formatMessage((0, $6oZiN.i18n).feedbackTitle);
        $[37] = intl;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== intl) {
        t16 = intl.formatMessage((0, $6oZiN.i18n).feedbackDescription);
        $[39] = intl;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== intl) {
        t17 = intl.formatMessage((0, $6oZiN.i18n).feedbackConfirmation);
        $[41] = intl;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== intl) {
        t18 = intl.formatMessage((0, $6oZiN.i18n).feedbackConfirmationDescription);
        $[43] = intl;
        $[44] = t18;
    } else t18 = $[44];
    let t19;
    if ($[45] !== intl) {
        t19 = intl.formatMessage((0, $6oZiN.i18n).feedbackSubmit);
        $[45] = intl;
        $[46] = t19;
    } else t19 = $[46];
    let t20;
    if ($[47] !== intl) {
        t20 = intl.formatMessage((0, $6oZiN.i18n).feedbackCancel);
        $[47] = intl;
        $[48] = t20;
    } else t20 = $[48];
    const t21 = !spaceKey ? secondFeedback : undefined;
    let t22;
    if ($[49] !== completed || $[50] !== handleFormData || $[51] !== questions || $[52] !== reactions || $[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== t20 || $[59] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6sytf.SatisfactionSurveyComponent), {
            title: t15,
            description: t16,
            finalTitle: t17,
            finalDescription: t18,
            submitButtonText: t19,
            closeButtonText: t20,
            reactionTitles: reactions,
            formQuestions: questions,
            isOnFinalStage: completed,
            onInteraction: handleFormData,
            customFields: t21
        });
        $[49] = completed;
        $[50] = handleFormData;
        $[51] = questions;
        $[52] = reactions;
        $[53] = t15;
        $[54] = t16;
        $[55] = t17;
        $[56] = t18;
        $[57] = t19;
        $[58] = t20;
        $[59] = t21;
        $[60] = t22;
    } else t22 = $[60];
    return t22;
};
const $c9b58423be6b0f98$export$17f0bdedcc6ce875 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { closeSurvey: closeSurvey, entityId: entityId, recIds: recIds, sources: sources, spaceKey: spaceKey, shouldReturnFocus: shouldReturnFocus } = t0;
    let t1;
    if ($[0] !== closeSurvey || $[1] !== entityId || $[2] !== recIds || $[3] !== sources || $[4] !== spaceKey) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9b58423be6b0f98$export$a50d500033c15d61, {
            closeSurvey: closeSurvey,
            entityId: entityId,
            sources: sources,
            recIds: recIds,
            spaceKey: spaceKey
        });
        $[0] = closeSurvey;
        $[1] = entityId;
        $[2] = recIds;
        $[3] = sources;
        $[4] = spaceKey;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== shouldReturnFocus || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "-feedback-survey"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60KP5.SatisfactionSurveyModal), {
            size: "medium",
            shouldReturnFocus: shouldReturnFocus
        }, t1));
        $[6] = shouldReturnFocus;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};









var $6f0Oj = parcelRequire("6f0Oj");

var $cwkWT = parcelRequire("cwkWT");

var $ecnYn = parcelRequire("ecnYn");






















var $71GjD = parcelRequire("71GjD");


var $AXitC = parcelRequire("AXitC");











var $jJK3p = parcelRequire("jJK3p");




const $5113cbd45b7d83ee$var$linkStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5113cbd45b7d83ee$var$AuthorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8wadc _1pbyidpf _o5721q9c _1e0c1txw _4cvr1h6o _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact && "_17kn15vq _1hrp15vq _10ca1q9c _x3fa1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $5113cbd45b7d83ee$export$cae754750d6ddba6 = ()=>{
    const $ = (0, $frIzR.c)(7);
    const pageCard = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    if ("history" in pageCard && "creatorId" in pageCard) {
        const hasAuthor = pageCard.history?.ownedBy?.displayName;
        let t0;
        if ($[0] !== hasAuthor || $[1] !== pageCard.creatorId || $[2] !== pageCard.history) {
            t0 = hasAuthor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5113cbd45b7d83ee$var$AuthorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                userId: pageCard.creatorId,
                fullName: pageCard.history.ownedBy.displayName,
                referralSource: "pageCard"
            })) : null;
            $[0] = hasAuthor;
            $[1] = pageCard.creatorId;
            $[2] = pageCard.history;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    if ("createdBy" in pageCard) {
        const hasAuthor_0 = pageCard.createdBy?.displayName;
        let t0;
        if ($[4] !== hasAuthor_0 || $[5] !== pageCard.createdBy) {
            t0 = hasAuthor_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5113cbd45b7d83ee$var$AuthorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                userId: pageCard.createdBy.accountId,
                fullName: pageCard.createdBy.displayName,
                referralSource: "pageCard"
            })) : null;
            $[4] = hasAuthor_0;
            $[5] = pageCard.createdBy;
            $[6] = t0;
        } else t0 = $[6];
        return t0;
    }
    return null;
};


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $9CEYG = parcelRequire("9CEYG");

var $63k9q = parcelRequire("63k9q");

const $673d28836402b3d5$var$StyledCard = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dDr80.Card) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4u2gc _1e0c1txw _4t3i12am _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$var$StyledCardWithHover = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $673d28836402b3d5$var$StyledCard : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_irr3ufnl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$var$GridCardStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    maxHeight: '50px'
});
const $673d28836402b3d5$var$Header = (0, $ecnYn.xcss)({
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 'space.150',
    paddingInlineStart: 'space.050'
});
const $673d28836402b3d5$var$HeaderSmallCard = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $673d28836402b3d5$var$IconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syazdgkc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$var$TitlesContainer = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    overflowWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $673d28836402b3d5$var$TitlesContainerSmallCard = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $673d28836402b3d5$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0ccj1k _1yyjcs5v _sudp1e54 _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $673d28836402b3d5$export$9f35c824a9d0b65b = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { showCardsAsListitem: t1 } = t0;
    const showCardsAsListitem = t1 === undefined ? true : t1;
    const { smallCard: smallCard } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const t2 = smallCard ? $673d28836402b3d5$var$StyledCardWithHover : $673d28836402b3d5$var$StyledCard;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
            featureAttributionCode: (0, $71GjD.FeatureCode).EOP_REC
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== smallCard) {
        t4 = [
            $673d28836402b3d5$var$Header,
            ...smallCard ? [
                $673d28836402b3d5$var$HeaderSmallCard
            ] : []
        ];
        $[1] = smallCard;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($673d28836402b3d5$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null));
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== smallCard) {
        t6 = [
            $673d28836402b3d5$var$TitlesContainer,
            ...smallCard ? [
                $673d28836402b3d5$var$TitlesContainerSmallCard
            ] : []
        ];
        $[4] = smallCard;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($673d28836402b3d5$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), null));
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5113cbd45b7d83ee$export$cae754750d6ddba6), null);
        $[6] = t7;
        $[7] = t8;
    } else {
        t7 = $[6];
        t8 = $[7];
    }
    let t9;
    if ($[8] !== t6) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t6
        }, t7, t8);
        $[8] = t6;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t4 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $673d28836402b3d5$var$GridCardStyles,
            testId: "page-card-end-of-page-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t4
        }, t5, t9));
        $[10] = t4;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== showCardsAsListitem || $[14] !== t10 || $[15] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
            StyledCard: t2,
            isListitem: showCardsAsListitem
        }, t3, t10);
        $[13] = showCardsAsListitem;
        $[14] = t10;
        $[15] = t2;
        $[16] = t11;
    } else t11 = $[16];
    return t11;
};


var $kzTi3 = parcelRequire("kzTi3");








var $lGgRw = parcelRequire("lGgRw");






















var $jSnXV = parcelRequire("jSnXV");

const $ea262e0136b0745d$var$HOVER_DELAY_TIME = 300;
const $ea262e0136b0745d$var$CLOSE_DELAY_TIME = 400;
const $ea262e0136b0745d$export$65b46b17148edcc8 = ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const isMouseInsideRef = (0, $42omo.useRef)(false);
    const onMouseLeaveDebounce = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!isMouseInsideRef.current) setIsOpen(false);
    }, $ea262e0136b0745d$var$CLOSE_DELAY_TIME);
    const onMouseEnterDebounce = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (isMouseInsideRef.current) setIsOpen(true);
    }, $ea262e0136b0745d$var$HOVER_DELAY_TIME);
    const onMouseEnter = ()=>{
        isMouseInsideRef.current = true;
        onMouseEnterDebounce();
    };
    const onMouseLeave = ()=>{
        isMouseInsideRef.current = false;
        onMouseLeaveDebounce();
    };
    const onMouseEnterIcon = ()=>{
        isMouseInsideRef.current = false;
        setIsOpen(false);
    };
    const onMouseLeaveIcon = ()=>{
        isMouseInsideRef.current = true;
        setIsOpen(true);
    };
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            onMouseLeaveDebounce.cancel();
        };
    }, [
        onMouseLeaveDebounce
    ]);
    return {
        isOpen: isOpen,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseEnterIcon: onMouseEnterIcon,
        onMouseLeaveIcon: onMouseLeaveIcon
    };
};



var $jb4sa = parcelRequire("jb4sa");

/**
 * @generated SignedSource<<c4d50645b634bde7b71fc6e87ce8f91f>>
 * @relayHash ebdb3c83478a0febad213c0d0c5d0338
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a0d1407b5ab19a4145ae8260858ede976c05eb6eab7abab7555c4d0cc53792b
const $ffc55089e01e6d65$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v10 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v11 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v13 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v19 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ebdb3c83478a0febad213c0d0c5d0338",
            "id": "8a0d1407b5ab19a4145ae8260858ede976c05eb6eab7abab7555c4d0cc53792b",
            "metadata": {},
            "name": "PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery",
            "operationKind": "query",
            "text": "query PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id,title,type,subType,status,links{webui,editui},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},history{createdBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}},ownedBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}},space{id,key,alias,name},likes{count},version{by{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$ffc55089e01e6d65$var$node.hash = "f109efa4dac01c6b97a01fe95c90ba72";
var $ffc55089e01e6d65$export$2e2bcd8739ae039 = $ffc55089e01e6d65$var$node;






var $gdv5Z = parcelRequire("gdv5Z");





var $2Rith = parcelRequire("2Rith");


var $fXbFR = parcelRequire("fXbFR");











var $fOasY = parcelRequire("fOasY");





var $cxMI6 = parcelRequire("cxMI6");




const $916e3938ee5654db$var$PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery = (0, $ffc55089e01e6d65$export$2e2bcd8739ae039);
const $916e3938ee5654db$export$fec5aea78c76fcc6 = ({ id: id, type: type, showAISnippets: showAISnippets, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, update: update })=>{
    const popupPageCardRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(popupPageCardRef);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'spacePageCard',
                    source: 'endOfPageRecommendations',
                    actionSubjectId: 'endOfPageRecommendations',
                    attributes: {
                        contentId: id,
                        dwellTime: getDwellTime(),
                        isAiSnippet: showAISnippets
                    }
                }
            }).fire();
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)($916e3938ee5654db$var$PopupPageCardViewWithAISnippetSpaceHoverPageCardQuery, {
        variables: {
            id: id
        },
        __callerPackage__: "@confluence/page-card"
    });
    const shouldRenderContent = (0, $42omo.useMemo)(()=>Boolean(!error && !loading && data?.singleContent), [
        error,
        loading,
        data
    ]);
    const aiAnalyticsConfig = (0, $42omo.useMemo)(()=>({
            product: 'confluence',
            subproduct: 'confluence',
            source: 'confluencePage',
            aiFeatureName: 'aiSnippet',
            proactiveGeneratedAI: 1,
            userGeneratedAI: 0,
            additionalAttributes: {
                contentId: data?.singleContent?.id,
                contentType: data?.singleContent?.type,
                from: (0, $71GjD.FeatureCode).EOP_REC_CARD
            }
        }), [
        data?.singleContent?.id,
        data?.singleContent?.type
    ]);
    return shouldRenderContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: popupPageCardRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: aiAnalyticsConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jb4sa.PageCardContextProvider), {
        data: (0, $cxMI6.transformSpaceContent)(data?.singleContent),
        appearance: "popup-view",
        analyticsData: {
            attributes: {
                from: (0, $71GjD.FeatureCode).EOP_REC_CARD
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fOasY.PopupViewWithAISnippet), {
        isEndOfPage: true,
        contentId: id,
        contentType: type,
        onLoadComplete: ()=>update(),
        shouldUseAISnippetPlatformComponent: true
    }))))) : null;
};


const $f645ea7970507757$var$pageRecCardContainer = (0, $ecnYn.xcss)({
    height: '100%'
});
const $f645ea7970507757$var$popupCardStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large'
});
const $f645ea7970507757$export$2d4bbdf98c1d6ca4 = (t0)=>{
    const $ = (0, $frIzR.c)(45);
    const { children: children, wrapperProps: wrapperProps, isCompactView: isCompactView } = t0;
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isOpen: isOpen, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseEnterIcon: onMouseEnterIcon, onMouseLeaveIcon: onMouseLeaveIcon } = (0, $ea262e0136b0745d$export$65b46b17148edcc8)();
    const [isHoveringInfoIcon, setIsHoveringInfoIcon] = (0, $42omo.useState)(false);
    const { id: id, type: type } = wrapperProps.data;
    let t1;
    if ($[0] !== isAdminHubAIEnabled || $[1] !== isHoveringInfoIcon || $[2] !== onMouseEnter) {
        t1 = ()=>{
            if (isAdminHubAIEnabled) (0, $6mKj3.manuallyLogExpExposure)("confluence_ai_enabled_related_pages_snippets");
            else (0, $6mKj3.manuallyLogExpExposure)("confluence_ai_disabled_related_pages_snippets");
            if (isHoveringInfoIcon) return;
            onMouseEnter();
        };
        $[0] = isAdminHubAIEnabled;
        $[1] = isHoveringInfoIcon;
        $[2] = onMouseEnter;
        $[3] = t1;
    } else t1 = $[3];
    const onMouseEnterWrapper = t1;
    let t2;
    if ($[4] !== isHoveringInfoIcon || $[5] !== onMouseLeave) {
        t2 = ()=>{
            if (isHoveringInfoIcon) return;
            onMouseLeave();
        };
        $[4] = isHoveringInfoIcon;
        $[5] = onMouseLeave;
        $[6] = t2;
    } else t2 = $[6];
    const onMouseLeaveWrapper = t2;
    let t3;
    if ($[7] !== createAnalyticsEvent || $[8] !== id || $[9] !== type) {
        t3 = (action)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: "globalPageCard",
                    source: "endOfPageRecommendations",
                    attributes: {
                        contentType: type,
                        contentId: id,
                        from: (0, $71GjD.FeatureCode).EOP_REC_CARD,
                        view: "end-of-page-rec-popup-view"
                    }
                }
            }).fire();
        };
        $[7] = createAnalyticsEvent;
        $[8] = id;
        $[9] = type;
        $[10] = t3;
    } else t3 = $[10];
    const fireAnalyticsEvent = t3;
    let t4;
    if ($[11] !== children || $[12] !== isCompactView || $[13] !== onMouseEnterIcon || $[14] !== onMouseEnterWrapper || $[15] !== onMouseLeaveIcon || $[16] !== onMouseLeaveWrapper || $[17] !== wrapperProps) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $f645ea7970507757$var$pageRecCardContainer,
                ...triggerProps,
                onMouseEnter: onMouseEnterWrapper,
                onMouseLeave: onMouseLeaveWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jb4sa.PageCardContextProvider), {
                ...wrapperProps,
                appearance: isCompactView ? "compact-end-of-page" : "end-of-page"
            }, children(setIsHoveringInfoIcon, onMouseLeaveIcon, onMouseEnterIcon)));
        $[11] = children;
        $[12] = isCompactView;
        $[13] = onMouseEnterIcon;
        $[14] = onMouseEnterWrapper;
        $[15] = onMouseLeaveIcon;
        $[16] = onMouseLeaveWrapper;
        $[17] = wrapperProps;
        $[18] = t4;
    } else t4 = $[18];
    const triggerContent = t4;
    let t5;
    if ($[19] !== fireAnalyticsEvent) {
        t5 = /*#__PURE__*/ (0, $42omo.forwardRef)((t6, ref)=>{
            const { "data-testid": testId, shouldRenderToParent: _shouldRenderToParent, shouldFitContainer: _shouldFitContainer, shouldFitViewport: _shouldFitViewport, isReferenceHidden: _isReferenceHidden, ...props } = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                testId: testId,
                ...props,
                ref: ref,
                xcss: $f645ea7970507757$var$popupCardStyles,
                onMouseEnter: ()=>fireAnalyticsEvent("hovered"),
                onClickCapture: ()=>fireAnalyticsEvent("clicked")
            });
        });
        $[19] = fireAnalyticsEvent;
        $[20] = t5;
    } else t5 = $[20];
    const PopupComponent = t5;
    const isInAIEnabledSnippetsExp = isAdminHubAIEnabled && type !== "blogpost";
    let t6;
    if ($[21] !== isInAIEnabledSnippetsExp) {
        t6 = isInAIEnabledSnippetsExp && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ai_enabled_related_pages_snippets", "cohort", "show_ai_snippet");
        $[21] = isInAIEnabledSnippetsExp;
        $[22] = t6;
    } else t6 = $[22];
    const isAISnippetHoverEnabled = t6;
    const isAIWithExcerptExp = isInAIEnabledSnippetsExp && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ai_enabled_related_pages_snippets", "cohort", "show_snippet");
    const isNonAIHoverEnabled = !isInAIEnabledSnippetsExp && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ai_disabled_related_pages_snippets", "cohort", "show_snippet");
    if (isAISnippetHoverEnabled || isAIWithExcerptExp || isNonAIHoverEnabled) {
        let t7;
        if ($[23] !== triggerContent) {
            t7 = (triggerProps_0)=>triggerContent(triggerProps_0);
            $[23] = triggerContent;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== id || $[26] !== isAISnippetHoverEnabled || $[27] !== onMouseEnterWrapper || $[28] !== onMouseLeaveWrapper || $[29] !== type) {
            t8 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $916e3938ee5654db$export$fec5aea78c76fcc6), {
                    id: id,
                    type: type,
                    showAISnippets: isAISnippetHoverEnabled,
                    onMouseEnter: onMouseEnterWrapper,
                    onMouseLeave: onMouseLeaveWrapper,
                    update: props_0.update
                });
            $[25] = id;
            $[26] = isAISnippetHoverEnabled;
            $[27] = onMouseEnterWrapper;
            $[28] = onMouseLeaveWrapper;
            $[29] = type;
            $[30] = t8;
        } else t8 = $[30];
        let t9;
        if ($[31] !== PopupComponent || $[32] !== isOpen || $[33] !== t7 || $[34] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
                popupComponent: PopupComponent,
                trigger: t7,
                isOpen: isOpen,
                autoFocus: false,
                content: t8,
                placement: "top-start"
            });
            $[31] = PopupComponent;
            $[32] = isOpen;
            $[33] = t7;
            $[34] = t8;
            $[35] = t9;
        } else t9 = $[35];
        return t9;
    }
    let t7;
    if ($[36] !== children) {
        t7 = children();
        $[36] = children;
        $[37] = t7;
    } else t7 = $[37];
    let t8;
    if ($[38] !== t7 || $[39] !== wrapperProps) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jb4sa.PageCardContextProvider), {
            ...wrapperProps,
            appearance: "end-of-page"
        }, t7);
        $[38] = t7;
        $[39] = wrapperProps;
        $[40] = t8;
    } else t8 = $[40];
    let t9;
    if ($[41] !== onMouseEnterWrapper || $[42] !== onMouseLeaveWrapper || $[43] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f645ea7970507757$var$pageRecCardContainer,
            onMouseEnter: onMouseEnterWrapper,
            onMouseLeave: onMouseLeaveWrapper
        }, t8);
        $[41] = onMouseEnterWrapper;
        $[42] = onMouseLeaveWrapper;
        $[43] = t8;
        $[44] = t9;
    } else t9 = $[44];
    return t9;
};


const $cbfa55b3be44c29a$export$8da2c1e40d5a0791 = (wrapperProps)=>{
    const $ = (0, $frIzR.c)(6);
    let t0;
    if ($[0] !== wrapperProps.isCompactView || $[1] !== wrapperProps.showCardsAsListitem) {
        t0 = ()=>wrapperProps.isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $673d28836402b3d5$export$9f35c824a9d0b65b), {
                showCardsAsListitem: wrapperProps.showCardsAsListitem
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kzTi3.EndOfPageView), {
                showCardsAsListitem: wrapperProps.showCardsAsListitem
            });
        $[0] = wrapperProps.isCompactView;
        $[1] = wrapperProps.showCardsAsListitem;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0 || $[4] !== wrapperProps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f645ea7970507757$export$2d4bbdf98c1d6ca4), {
            wrapperProps: wrapperProps,
            isCompactView: true
        }, t0);
        $[3] = t0;
        $[4] = wrapperProps;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};


const $8d104eedf2f18b6d$var$TwoCardWrapperWidth = (0, $ecnYn.xcss)({
    maxWidth: '480px'
});
const $8d104eedf2f18b6d$var$ThreeCardWrapperWidth = (0, $ecnYn.xcss)({
    maxWidth: '320px'
});
const $8d104eedf2f18b6d$var$BigCardHeight = (0, $ecnYn.xcss)({
    height: '128px'
});
const $8d104eedf2f18b6d$var$getColumnsBasedOnNumberOfCards = (totalCards)=>{
    const fixedTwoColumns = '1fr 1fr';
    const autoFitColumns = 'repeat(auto-fit, minmax(320px, 1fr))';
    switch(totalCards){
        case 1:
        case 2:
            return fixedTwoColumns;
        default:
            return autoFitColumns;
    }
};
const $8d104eedf2f18b6d$var$getCardStyles = (totalCards)=>{
    let stylesArray;
    switch(totalCards){
        case 1:
        case 2:
        case 4:
            stylesArray = [
                $8d104eedf2f18b6d$var$TwoCardWrapperWidth
            ];
            break;
        default:
            stylesArray = [
                $8d104eedf2f18b6d$var$ThreeCardWrapperWidth
            ];
            break;
    }
    stylesArray.push($8d104eedf2f18b6d$var$BigCardHeight);
    return stylesArray;
};
const $8d104eedf2f18b6d$export$ad5c1ee2c44a1a7f = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { pageCardData: pageCardData, pageRecStrategy: pageRecStrategy, entityId: entityId, isCompact: isCompact } = t0;
    let t1;
    if ($[0] !== pageCardData.length) {
        t1 = $8d104eedf2f18b6d$var$getColumnsBasedOnNumberOfCards(pageCardData.length);
        $[0] = pageCardData.length;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== entityId || $[3] !== isCompact || $[4] !== pageCardData || $[5] !== pageRecStrategy) {
        let t3;
        if ($[7] !== entityId || $[8] !== isCompact || $[9] !== pageCardData.length || $[10] !== pageRecStrategy) {
            t3 = (node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    key: node.id,
                    xcss: ()=>$8d104eedf2f18b6d$var$getCardStyles(pageCardData.length),
                    role: "listitem"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbfa55b3be44c29a$export$8da2c1e40d5a0791), {
                    data: node,
                    ranking: i,
                    analyticsData: {
                        source: "endOfPageRecommendations",
                        attributes: {
                            strategy: pageRecStrategy ? pageRecStrategy[i % pageRecStrategy.length] : null,
                            mainContentId: entityId
                        }
                    },
                    isCompactView: isCompact,
                    showCardsAsListitem: false
                }));
            $[7] = entityId;
            $[8] = isCompact;
            $[9] = pageCardData.length;
            $[10] = pageRecStrategy;
            $[11] = t3;
        } else t3 = $[11];
        t2 = pageCardData.map(t3);
        $[2] = entityId;
        $[3] = isCompact;
        $[4] = pageCardData;
        $[5] = pageRecStrategy;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[12] !== t1 || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
            templateColumns: t1,
            gap: "space.200",
            role: "list"
        }, t2);
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
};












var $dpPtd = parcelRequire("dpPtd");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");








var $6bd6t = parcelRequire("6bd6t");


var $dchHi = parcelRequire("dchHi");














var $eEA8O = parcelRequire("eEA8O");





var $8tSmd = parcelRequire("8tSmd");


var $eXmBZ = parcelRequire("eXmBZ");


var $lsxnT = parcelRequire("lsxnT");










const $533af8c3a7fd70b6$export$5194d34db5ab5ce4 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { toggleInfo: toggleInfo, showFeedbackButton: showFeedbackButton, clickFeedback: clickFeedback, isInfoOpen: isInfoOpen, handleInfoButtonRef: handleInfoButtonRef } = t0;
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== clickFeedback || $[1] !== showFeedbackButton) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.InfoContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6oZiN.i18n).info), showFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.FeedbackContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                onClick: clickFeedback
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6oZiN.i18n).feedback))));
        $[0] = clickFeedback;
        $[1] = showFeedbackButton;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== handleInfoButtonRef || $[4] !== isInfoOpen || $[5] !== toggleInfo) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                onClick: toggleInfo,
                isSelected: isInfoOpen,
                testId: "eop-info-button",
                spacing: (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false) ? "compact" : undefined,
                icon: (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false) ? $533af8c3a7fd70b6$var$_temp : (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6oZiN.i18n).infoButton),
                ...triggerProps,
                ref: handleInfoButtonRef(triggerProps)
            });
        $[3] = handleInfoButtonRef;
        $[4] = isInfoOpen;
        $[5] = toggleInfo;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== Popup || $[8] !== isInfoOpen || $[9] !== t1 || $[10] !== t2 || $[11] !== toggleInfo) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
            shouldRenderToParent: true,
            strategy: "absolute",
            onClose: toggleInfo,
            content: t1,
            isOpen: isInfoOpen,
            placement: "top-start",
            trigger: t2
        });
        $[7] = Popup;
        $[8] = isInfoOpen;
        $[9] = t1;
        $[10] = t2;
        $[11] = toggleInfo;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
function $533af8c3a7fd70b6$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        ...iconProps,
        size: "small"
    });
}


const $e0cc7e4e5e2b854b$var$i18n = (0, $aXWIB.defineMessages)({
    headerTitle: {
        id: "page-recommendations.end-of-page-recommendation-compact-header.title",
        defaultMessage: "Related content"
    },
    feedbackTitle: {
        id: "page-recommendations.end-of-page-recommendation-compact-header.feedback.title",
        defaultMessage: "Help us improve Confluence"
    },
    feedbackSummaryPlaceholder: {
        id: "page-recommendations.end-of-page-recommendation-compact-header.feedback.summary.placeholder",
        defaultMessage: "What did we do well? What could be improved?"
    }
});
const $e0cc7e4e5e2b854b$var$styles = {
    container: "_n3tdpxbi"
};
const $e0cc7e4e5e2b854b$export$dd7678881b84ee46 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { toggleInfo: toggleInfo, isInfoOpen: isInfoOpen, handleInfoButtonRef: handleInfoButtonRef, analyticsProperties: analyticsProperties, contentId: contentId } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    analyticsProperties?.additionalAnalyticsAttributes?.contentType;
    const t1 = analyticsProperties?.additionalAnalyticsAttributes?.contentType;
    let t2;
    if ($[0] !== contentId || $[1] !== t1) {
        t2 = {
            product: "confluence",
            subproduct: "confluence",
            source: "endOfPageRecommendationHeader",
            aiFeatureName: "endOfPageRecommendation",
            proactiveGeneratedAI: 1,
            userGeneratedAI: 0,
            additionalAttributes: {
                contentId: contentId,
                contentType: t1,
                from: (0, $71GjD.FeatureCode).EOP_REC
            }
        };
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const aiAnalyticsConfig = t2;
    let t3;
    if ($[3] !== analyticsProperties || $[4] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6bd6t.SmartsFeedbackComponent), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            feedbackTitle: $e0cc7e4e5e2b854b$var$i18n.feedbackTitle,
            feedbackSummaryPlaceholder: $e0cc7e4e5e2b854b$var$i18n.feedbackSummaryPlaceholder,
            aiContentType: "suggestion"
        });
        $[3] = analyticsProperties;
        $[4] = contentId;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== aiAnalyticsConfig || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
            entrypointId: "d15eac98-e451-452a-84ce-dcf70888cb52"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
            config: aiAnalyticsConfig
        }, t3)));
        $[6] = aiAnalyticsConfig;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const feedbackComponent = t4;
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($e0cc7e4e5e2b854b$var$i18n.headerTitle);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "medium",
            weight: "medium"
        }, t5);
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== handleInfoButtonRef || $[14] !== isInfoOpen || $[15] !== toggleInfo) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $533af8c3a7fd70b6$export$5194d34db5ab5ce4), {
            toggleInfo: toggleInfo,
            showFeedbackButton: false,
            isInfoOpen: isInfoOpen,
            handleInfoButtonRef: handleInfoButtonRef
        });
        $[13] = handleInfoButtonRef;
        $[14] = isInfoOpen;
        $[15] = toggleInfo;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== feedbackComponent) {
        t8 = (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false) ? null : feedbackComponent;
        $[17] = feedbackComponent;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            spread: "space-between",
            xcss: $e0cc7e4e5e2b854b$var$styles.container,
            testId: "eop-compact-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center"
        }, t6, t7, t8));
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};



















var $bWLcG = parcelRequire("bWLcG");



const $58aae0f847bd3c55$var$endOfPageRecContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: 'space.250',
    margin: 'auto',
    width: '87.5%',
    [(0, $bWLcG.media).above.lg]: {
        maxWidth: '1000px'
    }
});
const $58aae0f847bd3c55$var$relatedPagesSpecSectionSpacingStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.300'
});
const $58aae0f847bd3c55$var$maxWidthStyles = (0, $ecnYn.xcss)({
    width: 'unset',
    maxWidth: 'unset'
});
const $58aae0f847bd3c55$export$762e81e2e5e5fd21 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, ssrPlaceholderIdProp: ssrPlaceholderIdProp, isDefaultWidth: isDefaultWidth, isCompactRelatedContentSpecSpacing: isCompactRelatedContentSpecSpacing } = t0;
    const componentRef = (0, $42omo.useRef)(null);
    const t1 = isCompactRelatedContentSpecSpacing && $58aae0f847bd3c55$var$relatedPagesSpecSectionSpacingStyles;
    const t2 = !isDefaultWidth && $58aae0f847bd3c55$var$maxWidthStyles;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = [
            $58aae0f847bd3c55$var$endOfPageRecContainerStyles,
            t1,
            t2
        ];
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== ssrPlaceholderIdProp || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            "data-testid": "test-rec",
            "data-vc": "end-of-page-recommendation-component",
            ref: componentRef,
            testId: "test-rec",
            xcss: t3,
            ...ssrPlaceholderIdProp
        }, children);
        $[3] = children;
        $[4] = ssrPlaceholderIdProp;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
};


const $e559508598822550$var$GRID_CARD_LIMIT = 6;
const $e559508598822550$var$GRID_CARD_LIMIT_LIVE_PAGES = 4;
const $e559508598822550$export$4cd5fff7a629299d = (t0)=>{
    const $ = (0, $frIzR.c)(70);
    const { entityId: entityId, entityType: entityType, pageCardData: pageCardData, data: data, pageWidthType: pageWidthType, isLivePage: isLivePage, spaceKey: spaceKey } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isInfoOpen, setInfoOpen] = (0, $42omo.useState)(false);
    const [showFeedbackForm, setFeedbackForm] = (0, $42omo.useState)(false);
    const [isCollapsed, setIsCollapsed] = (0, $42omo.useState)(false);
    const compRef = (0, $42omo.useRef)(null);
    const infoButtonRef = (0, $42omo.useRef)(null);
    const [, actions] = (0, $isEtk.useContentState)();
    const gridCardLimit = isLivePage ? $e559508598822550$var$GRID_CARD_LIMIT_LIVE_PAGES : $e559508598822550$var$GRID_CARD_LIMIT;
    let t1;
    if ($[0] !== gridCardLimit || $[1] !== pageCardData) {
        t1 = pageCardData?.slice(0, gridCardLimit).map($e559508598822550$var$_temp);
        $[0] = gridCardLimit;
        $[1] = pageCardData;
        $[2] = t1;
    } else t1 = $[2];
    const pageRecIds = t1;
    let strategiesArray;
    if ($[3] !== data?.getRecommendedPages?.recommendedPages || $[4] !== gridCardLimit) {
        const recommendations = data?.getRecommendedPages?.recommendedPages?.slice(0, gridCardLimit) || [];
        strategiesArray = Array(gridCardLimit).fill("NULL");
        recommendations.forEach((rec, index)=>{
            strategiesArray[index] = rec.strategy.map($e559508598822550$var$_temp2).sort().join("");
        });
        $[3] = data?.getRecommendedPages?.recommendedPages;
        $[4] = gridCardLimit;
        $[5] = strategiesArray;
    } else strategiesArray = $[5];
    const contentRecsStrategies = strategiesArray;
    const spaceId = data?.space?.id;
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            position: "right",
            hideTooltipOnClick: true
        };
        $[6] = t2;
    } else t2 = $[6];
    const tooltipOptions = t2;
    let t3;
    if ($[7] !== createAnalyticsEvent || $[8] !== entityId || $[9] !== entityType || $[10] !== isInfoOpen) {
        t3 = ()=>{
            if (!isInfoOpen) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: entityType,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "endOfPageRecommendationsInfoButton",
                    attributes: {
                        contentId: entityId
                    }
                }
            }).fire();
            setInfoOpen(!isInfoOpen);
        };
        $[7] = createAnalyticsEvent;
        $[8] = entityId;
        $[9] = entityType;
        $[10] = isInfoOpen;
        $[11] = t3;
    } else t3 = $[11];
    const toggleInfo = t3;
    let t4;
    if ($[12] !== createAnalyticsEvent || $[13] !== entityId || $[14] !== entityType || $[15] !== showFeedbackForm) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: entityType,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "endOfPageRecommendationsFeedback",
                    attributes: {
                        contentId: entityId
                    }
                }
            }).fire();
            setInfoOpen(false);
            setFeedbackForm(!showFeedbackForm);
        };
        $[12] = createAnalyticsEvent;
        $[13] = entityId;
        $[14] = entityType;
        $[15] = showFeedbackForm;
        $[16] = t4;
    } else t4 = $[16];
    const clickFeedback = t4;
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setFeedbackForm(false);
        };
        $[17] = t5;
    } else t5 = $[17];
    const closeSurvey = t5;
    let t6;
    if ($[18] !== contentRecsStrategies || $[19] !== createAnalyticsEvent || $[20] !== entityId || $[21] !== entityType || $[22] !== spaceId) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: entityType,
                    action: "observed",
                    actionSubject: "endOfPageRecommendations",
                    attributes: {
                        strategies: contentRecsStrategies
                    },
                    objectId: entityId,
                    containerId: spaceId
                }
            }).fire();
        };
        $[18] = contentRecsStrategies;
        $[19] = createAnalyticsEvent;
        $[20] = entityId;
        $[21] = entityType;
        $[22] = spaceId;
        $[23] = t6;
    } else t6 = $[23];
    const onObserved = t6;
    let t7;
    if ($[24] !== contentRecsStrategies || $[25] !== createAnalyticsEvent || $[26] !== entityId || $[27] !== entityType || $[28] !== isCollapsed || $[29] !== spaceId) {
        t7 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: entityType,
                    action: isCollapsed ? "expanded" : "collapsed",
                    actionSubject: "endOfPageRecommendations",
                    attributes: {
                        strategies: contentRecsStrategies
                    },
                    objectId: entityId,
                    containerId: spaceId
                }
            }).fire();
            setIsCollapsed(!isCollapsed);
        };
        $[24] = contentRecsStrategies;
        $[25] = createAnalyticsEvent;
        $[26] = entityId;
        $[27] = entityType;
        $[28] = isCollapsed;
        $[29] = spaceId;
        $[30] = t7;
    } else t7 = $[30];
    const onCollapseExpandClick = t7;
    (0, $fgRQY.useElementSeenCallback)(compRef, onObserved);
    let t8;
    if ($[31] !== contentRecsStrategies || $[32] !== createAnalyticsEvent || $[33] !== entityId || $[34] !== entityType || $[35] !== pageRecIds?.length || $[36] !== spaceId) {
        t8 = ()=>{
            if (!!pageRecIds?.length && pageRecIds?.length > 1) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: entityType,
                    action: "rendered",
                    actionSubject: "endOfPageRecommendations",
                    attributes: {
                        strategies: contentRecsStrategies
                    },
                    objectId: entityId,
                    containerId: spaceId
                }
            }).fire();
        };
        $[31] = contentRecsStrategies;
        $[32] = createAnalyticsEvent;
        $[33] = entityId;
        $[34] = entityType;
        $[35] = pageRecIds?.length;
        $[36] = spaceId;
        $[37] = t8;
    } else t8 = $[37];
    let t9;
    if ($[38] !== contentRecsStrategies || $[39] !== createAnalyticsEvent || $[40] !== entityId || $[41] !== entityType || $[42] !== pageRecIds || $[43] !== spaceId) {
        t9 = [
            createAnalyticsEvent,
            entityId,
            contentRecsStrategies,
            pageRecIds,
            spaceId,
            entityType
        ];
        $[38] = contentRecsStrategies;
        $[39] = createAnalyticsEvent;
        $[40] = entityId;
        $[41] = entityType;
        $[42] = pageRecIds;
        $[43] = spaceId;
        $[44] = t9;
    } else t9 = $[44];
    (0, $42omo.useEffect)(t8, t9);
    const isSSRed = window.__SSR_RENDERED__;
    let t10;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (triggerProps)=>(node)=>{
                infoButtonRef.current = node;
                triggerProps.ref(node);
            };
        $[45] = t10;
    } else t10 = $[45];
    const handleInfoButtonRef = t10;
    let t11;
    if ($[46] !== pageWidthType) {
        t11 = pageWidthType ? JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT : false;
        $[46] = pageWidthType;
        $[47] = t11;
    } else t11 = $[47];
    const isDefaultWidth = t11;
    pageCardData?.length;
    const t12 = pageCardData?.length || 0;
    let t13;
    if ($[48] !== contentRecsStrategies || $[49] !== entityType || $[50] !== spaceId || $[51] !== spaceKey || $[52] !== t12) {
        t13 = {
            source: "endOfPageRecommendation",
            additionalAnalyticsAttributes: {
                contentType: entityType,
                strategies: contentRecsStrategies,
                spaceKey: spaceKey,
                spaceId: spaceId,
                recommendationCount: t12
            }
        };
        $[48] = contentRecsStrategies;
        $[49] = entityType;
        $[50] = spaceId;
        $[51] = spaceKey;
        $[52] = t12;
        $[53] = t13;
    } else t13 = $[53];
    const analyticsProperties = t13;
    let t14;
    if ($[54] !== actions || $[55] !== analyticsProperties || $[56] !== clickFeedback || $[57] !== contentRecsStrategies || $[58] !== entityId || $[59] !== gridCardLimit || $[60] !== isCollapsed || $[61] !== isDefaultWidth || $[62] !== isInfoOpen || $[63] !== onCollapseExpandClick || $[64] !== pageCardData || $[65] !== pageRecIds || $[66] !== showFeedbackForm || $[67] !== ssrPlaceholderIdProp || $[68] !== toggleInfo) {
        t14 = !!pageCardData?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !isSSRed && (actions?.addContentToBeLoaded("endOfPageRecommendation", "loading"), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58aae0f847bd3c55$export$762e81e2e5e5fd21), {
            isDefaultWidth: isDefaultWidth,
            ssrPlaceholderIdProp: ssrPlaceholderIdProp,
            isCompactRelatedContentSpecSpacing: (0, $6mKj3.expValEquals)("cc_ai_related_pages_compact", "cohort", "test") && (0, $6mKj3.expVal)("confluence_related_pages_remove_feedback_icons", "isEnabled", false)
        }, (0, $6mKj3.expValEquals)("cc_ai_related_pages_compact", "cohort", "test") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e0cc7e4e5e2b854b$export$dd7678881b84ee46), {
            toggleInfo: toggleInfo,
            isInfoOpen: isInfoOpen,
            handleInfoButtonRef: handleInfoButtonRef,
            analyticsProperties: analyticsProperties,
            contentId: entityId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.EndOfPageRecHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.HeaderFrontContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6oZiN.i18n).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $533af8c3a7fd70b6$export$5194d34db5ab5ce4), {
            toggleInfo: toggleInfo,
            clickFeedback: clickFeedback,
            isInfoOpen: isInfoOpen,
            handleInfoButtonRef: handleInfoButtonRef,
            showFeedbackButton: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.HeaderLineContainer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (iconProps)=>isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                    ...iconProps,
                    size: "small"
                }),
            label: isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6oZiN.i18n).expandButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6oZiN.i18n).collapseButton),
            onClick: onCollapseExpandClick,
            isTooltipDisabled: false,
            tooltip: tooltipOptions,
            testId: isCollapsed ? "eop-expand-button" : "eop-collapse-button"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: false
        }, !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "top",
            exitDirection: "top",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d104eedf2f18b6d$export$ad5c1ee2c44a1a7f), {
                isCompact: (0, $6mKj3.expValEquals)("cc_ai_related_pages_compact", "cohort", "test"),
                pageCardData: pageCardData.slice(0, gridCardLimit),
                pageRecStrategy: contentRecsStrategies,
                entityId: entityId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ref: compRef
            }))))), showFeedbackForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9b58423be6b0f98$export$17f0bdedcc6ce875), {
            closeSurvey: closeSurvey,
            entityId: entityId,
            recIds: pageRecIds,
            sources: contentRecsStrategies,
            shouldReturnFocus: infoButtonRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: entityId,
            metric: (0, $c992d301b5eec450$export$e03be33cf6ebb3ea)
        }), !isSSRed && (actions?.removeContentFromLoading("endOfPageRecommendation"), null)) : null;
        $[54] = actions;
        $[55] = analyticsProperties;
        $[56] = clickFeedback;
        $[57] = contentRecsStrategies;
        $[58] = entityId;
        $[59] = gridCardLimit;
        $[60] = isCollapsed;
        $[61] = isDefaultWidth;
        $[62] = isInfoOpen;
        $[63] = onCollapseExpandClick;
        $[64] = pageCardData;
        $[65] = pageRecIds;
        $[66] = showFeedbackForm;
        $[67] = ssrPlaceholderIdProp;
        $[68] = toggleInfo;
        $[69] = t14;
    } else t14 = $[69];
    return t14;
};
function $e559508598822550$var$_temp(content) {
    return content.id;
}
function $e559508598822550$var$_temp2(s) {
    return s.charAt(0);
}


const $b7fe165a47ee5163$var$endOfPageRecWrapperStyles = null;
const $b7fe165a47ee5163$var$EndOfPageRecommendation = /*#__PURE__*/ (0, $42omo.memo)(({ entityType: entityType, entityId: entityId, pageWidthType: pageWidthType, spaceKey: spaceKey, isLivePage: isLivePage = false })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [state] = (0, $isEtk.useContentState)();
    const skip = entityType !== 'page' && entityType !== 'blogpost';
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const baseQueryOptions = {
        variables: {
            type: entityType,
            id: entityId,
            exp: (0, $6mKj3.expVal)('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5'),
            key: spaceKey,
            keyString: spaceKey
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        skip: skip
    };
    const { error: error, loading: loading, data: data } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), baseQueryOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        ...baseQueryOptions,
        __callerPackage__: "@confluence/page-recommendations"
    });
    const pageCardData = (0, $42omo.useMemo)(()=>(0, $8dbvt.transformAndOrderRecs)(data?.getRecommendedPages?.recommendedPages), [
        data
    ]);
    const isEnabled = data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled && data?.getRecommendedPages?.status?.isEnabled && data?.getRecommendedPagesSpaceStatus?.defaultBehavior === (0, $6627c994dbd6ecf6$export$5e3c7f13be5cbe17).SHOWN;
    (0, $42omo.useEffect)(()=>{
        if (isEnabled) experienceTracker.start({
            name: (0, $irVI7.EOP_RECS_EXPERIENCE)
        });
    }, [
        experienceTracker,
        isEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEnabled && !loading) {
            if (error) experienceTracker.stopOnError({
                name: (0, $irVI7.EOP_RECS_EXPERIENCE),
                error: error
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.EOP_RECS_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        isEnabled,
        loading,
        error
    ]);
    if (error) return (0, $1uFM6.isUnauthorizedError)(error) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    if (skip || !pageCardData || pageCardData.length < 2 || !isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
        name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).EndOfPageRecommendation
    });
    const isContentReady = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined) || window.__SSR_RENDERED__ || state.isContentReady || isLivePage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            isLivePage && "_19pk1epz",
            "end-of-page-rec-wrapper"
        ]),
        "data-testid": "end-page-rec-wrapper",
        "data-vc": "end-of-page-recommendation",
        ...ssrPlaceholderIdProp
    }, isEnabled && isContentReady && (loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "EndOfPageRecommendation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ihn35.EndOfPageRecPlaceholderContainer), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: entityId,
        metric: (0, $c992d301b5eec450$export$e03be33cf6ebb3ea),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e559508598822550$export$4cd5fff7a629299d), {
        entityId: entityId,
        entityType: entityType,
        pageCardData: pageCardData,
        data: data,
        pageWidthType: pageWidthType,
        spaceKey: spaceKey,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
        name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).EndOfPageRecommendation
    }))));
});
const $b7fe165a47ee5163$export$bf75a220d4f45be1 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).SMARTS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7fe165a47ee5163$var$EndOfPageRecommendation, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["EndOfPageRecommendation"] = $b7fe165a47ee5163$export$bf75a220d4f45be1;

});

parcelRegister("fgRQY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $40c43516853cc93d$export$951d3821f04440e9 = (elementRef, onSeen, t0)=>{
    const $ = (0, $frIzR.c)(5);
    const threshold = t0 === undefined ? 1 : t0;
    const observerRef = (0, $42omo.useRef)();
    const hasIntersected = (0, $42omo.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== elementRef || $[1] !== onSeen || $[2] !== threshold) {
        t1 = ()=>{
            const disconnectObserver = ()=>{
                if (observerRef.current) {
                    observerRef.current.disconnect();
                    observerRef.current = undefined;
                }
            };
            const handleIntersect = (entries)=>{
                if (!hasIntersected.current && entries[0].isIntersecting) {
                    onSeen();
                    hasIntersected.current = true;
                    disconnectObserver();
                }
            };
            observerRef.current = new IntersectionObserver(handleIntersect, {
                threshold: threshold
            });
            if (elementRef.current) observerRef.current.observe(elementRef.current);
            return disconnectObserver;
        };
        t2 = [
            onSeen,
            elementRef,
            threshold
        ];
        $[0] = elementRef;
        $[1] = onSeen;
        $[2] = threshold;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
};
module.exports["useElementSeenCallback"] = $40c43516853cc93d$export$951d3821f04440e9;

});

parcelRegister("60KP5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $6c1ffe924c7fc373$export$f3dbdc3fe3ac5f78 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Wu3Kl",
    name: "SatisfactionSurveyModal",
    loader: async ()=>(await (parcelRequire("kE108"))).SatisfactionSurveyModal
});
module.exports["SatisfactionSurveyModal"] = $6c1ffe924c7fc373$export$f3dbdc3fe3ac5f78;

});

parcelRegister("kE108", function(module, exports) {

let $f07851e820c941ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f07851e820c941ab$var$load("f8xBv"),
    $f07851e820c941ab$var$load("9lDKI")
]).then(()=>parcelRequire('68LQc'));

});

parcelRegister("6sytf", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5c11c40f5d61c319$export$9102ca613e8d6cb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NK0Zc",
    name: "SatisfactionSurveyComponent",
    loader: async ()=>(await (parcelRequire("9wx3m"))).SatisfactionSurveyComponent
});
module.exports["SatisfactionSurveyComponent"] = $5c11c40f5d61c319$export$9102ca613e8d6cb;

});

parcelRegister("9wx3m", function(module, exports) {

let $6ef0bde76a2f0956$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ef0bde76a2f0956$var$load("f8xBv").then(()=>parcelRequire('21rGX'));

});

parcelRegister("6oZiN", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $fd94ae0dd1a4bd51$var$i18nBase = (0, $aXWIB.defineMessages)({
    title: {
        id: "page-recommendations.eop.title",
        defaultMessage: "Related content"
    },
    feedback: {
        id: "page-recommendations.eop.feedback.button",
        defaultMessage: "Give feedback"
    },
    info: {
        id: "page-recommendations.eop.feedback.info",
        defaultMessage: "These suggestions are automatically generated based on content that is viewed or organized together. Suggestions update over time and respect content restrictions."
    },
    hide: {
        id: "page-recommendations.eop.feedback.hide",
        defaultMessage: "Hide for everyone..."
    },
    modal_title: {
        id: "page-recommendations.eop.hide.modal.title",
        defaultMessage: "Hide related content for <b>everyone</b>?"
    },
    modal_cancel: {
        id: "page-recommendations.eop.hide.modal.cancel",
        defaultMessage: "Cancel"
    },
    modal_hide: {
        id: "page-recommendations.eop.hide.modal.hide.button",
        defaultMessage: "Hide for everyone"
    },
    modal_info: {
        id: "page-recommendations.eop.hide.modal.info",
        defaultMessage: "Suggestions for this content will be hidden from everyone."
    },
    modal_info_show: {
        id: "page-recommendations.eop.hide.modal.info.show",
        defaultMessage: "You can show related content again under advanced details."
    },
    space_setting_info: {
        id: "page-recommendations.eop.space.setting.info",
        defaultMessage: "Related content automatically generates suggestions based on content viewed or organized together. These will appear as a series of cards at the bottom of some pages, and may update over time."
    },
    space_setting_hide_toggle: {
        id: "page-recommendations.eop.space.setting.hide.toggle",
        defaultMessage: "Related content"
    },
    space_setting_default: {
        id: "page-recommendations.eop.space.setting.default",
        defaultMessage: "Default behavior"
    },
    space_setting_hidden: {
        id: "page-recommendations.eop.space.setting.default.hidden",
        defaultMessage: "Hidden on each page"
    },
    space_setting_shown: {
        id: "page-recommendations.eop.space.setting.default.shown",
        defaultMessage: "Shown on each page"
    },
    feedbackMessage: {
        id: "page-recommendations.related.pages.space.settings.feedback.section",
        defaultMessage: "What do you think of related content?"
    },
    feedbackButtonText: {
        id: "page-recommendations.related.pages.space.settings.feedback.button.text",
        defaultMessage: "Give feedback"
    },
    feedbackTitle: {
        id: "page-recommendations.feedback.title.v2",
        defaultMessage: "Thank you for trying out related content"
    },
    feedbackDescription: {
        id: "page-recommendations.feedback.description",
        defaultMessage: "How satisfied are you with related content?"
    },
    feedbackFollowup: {
        id: "page-recommendations.feedback.followup",
        defaultMessage: "Thanks for the feedback! What do you like about it? What could be improved?"
    },
    feedbackSecondFollowup: {
        id: "page-recommendations.feedback.followup.second",
        defaultMessage: "Any feedback on related content for this specific item?"
    },
    feedbackConfirmation: {
        id: "page-recommendations.feedback.confirmation",
        defaultMessage: "Feedback submitted"
    },
    feedbackConfirmationDescription: {
        id: "page-recommendations.feedback.confirmation.description.v2",
        defaultMessage: "Thank you for helping us improve related content!"
    },
    feedbackSubmit: {
        id: "page-recommendations.feedback.submit",
        defaultMessage: "Submit"
    },
    feedbackCancel: {
        id: "page-recommendations.feedback.cancel",
        defaultMessage: "Cancel"
    },
    terrible: {
        id: "page-recommendations.feedback.rating.terrible",
        defaultMessage: "terrible"
    },
    bad: {
        id: "page-recommendations.feedback.rating.bad",
        defaultMessage: "bad"
    },
    okay: {
        id: "page-recommendations.feedback.rating.okay",
        defaultMessage: "okay"
    },
    good: {
        id: "page-recommendations.feedback.rating.good",
        defaultMessage: "good"
    },
    great: {
        id: "page-recommendations.feedback.rating.great",
        defaultMessage: "great"
    },
    expandButton: {
        id: "page-recommendations.eop.expand.button",
        defaultMessage: "Expand"
    },
    collapseButton: {
        id: "page-recommendations.eop.collapse.button",
        defaultMessage: "Collapse"
    },
    infoButton: {
        id: "page-recommendations.eop.info",
        defaultMessage: "More info"
    },
    adminConfigFeedbackTitle: {
        id: "page-recommendations.admin-config.feedback.title",
        defaultMessage: "Help us improve Confluence"
    },
    adminConfigFeedbackSummaryPlaceholder: {
        id: "page-recommendations.admin-config.feedback.summary.placeholder",
        defaultMessage: "What did we do well? What could be improved?"
    }
});
const $fd94ae0dd1a4bd51$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    space_setting_hidden: {
        id: "page-recommendations.eop.space.setting.default.hidden.livedocs",
        defaultMessage: "Hidden on each page or live doc"
    },
    space_setting_shown: {
        id: "page-recommendations.eop.space.setting.default.shown.livedocs",
        defaultMessage: "Shown on each page or live doc"
    }
});
const $fd94ae0dd1a4bd51$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($fd94ae0dd1a4bd51$var$i18nBase, $fd94ae0dd1a4bd51$var$i18nLiveDocs);
module.exports["i18n"] = $fd94ae0dd1a4bd51$export$a7357cdd1f0b0168;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("jJK3p", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $aXWIB.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $aXWIB.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("fOasY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $i5WUp = parcelRequire("i5WUp");


var $fYQcF = parcelRequire("fYQcF");


var $71GjD = parcelRequire("71GjD");


var $bQm3c = parcelRequire("bQm3c");


var $AXitC = parcelRequire("AXitC");


var $5BwjK = parcelRequire("5BwjK");

var $qaY7H = parcelRequire("qaY7H");

var $aoeyL = parcelRequire("aoeyL");

var $c9Olr = parcelRequire("c9Olr");

var $dDr80 = parcelRequire("dDr80");

var $9CEYG = parcelRequire("9CEYG");

var $1R1bQ = parcelRequire("1R1bQ");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $9c44b8c40f625697$var$styles = (0, $ecnYn.xcss)({
    width: '400px'
});
const $9c44b8c40f625697$var$headerStyle = (0, $ecnYn.xcss)({
    width: '100%',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $9c44b8c40f625697$var$headerIconStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'flex-start'
});
const $9c44b8c40f625697$var$titleStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    textAlign: 'start',
    WebkitBoxPack: 'start'
});
const $9c44b8c40f625697$var$aiSnippetStyles = {
    container: "_1tke16xz _y3gnv2br _kq6x1jtm"
};
const $9c44b8c40f625697$export$28f0f82c7dd8d86e = (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, snippet: snippet, isEndOfPage: t1, contentId: contentId, contentType: contentType, onLoadComplete: onLoadComplete, shouldUseAISnippetPlatformComponent: t2 } = t0;
    const isEndOfPage = t1 === undefined ? false : t1;
    const shouldUseAISnippetPlatformComponent = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { excerpt: excerpt } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    let t3;
    if ($[0] !== isEndOfPage || $[1] !== shouldUseAISnippetPlatformComponent || $[2] !== snippet || $[3] !== trackAIResultAction) {
        t3 = ()=>{
            if (snippet || shouldUseAISnippetPlatformComponent) trackAIResultAction("aiSnippetCardClicked", {
                attributes: {
                    source: isEndOfPage ? "endOfPageRecommendations" : "pageTree"
                }
            });
        };
        $[0] = isEndOfPage;
        $[1] = shouldUseAISnippetPlatformComponent;
        $[2] = snippet;
        $[3] = trackAIResultAction;
        $[4] = t3;
    } else t3 = $[4];
    const handlePopupClick = t3;
    const t4 = isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD;
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
            shouldHideFolder: true,
            featureAttributionCode: t4
        });
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9c44b8c40f625697$var$headerIconStyle,
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null));
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            alignInline: "start",
            shouldWrap: false,
            grow: "fill",
            space: "space.100"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            xcss: $9c44b8c40f625697$var$headerStyle,
            alignBlock: "start",
            alignInline: "start",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9c44b8c40f625697$var$titleStyles,
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)));
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== cloudId || $[10] !== contentId || $[11] !== contentType || $[12] !== excerpt || $[13] !== isEndOfPage || $[14] !== onLoadComplete || $[15] !== userId) {
        t8 = excerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9c44b8c40f625697$var$aiSnippetStyles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId,
            source: isEndOfPage ? "endOfPageRecommendations" : "pageTree",
            onLoadComplete: onLoadComplete,
            fallbackText: excerpt,
            from: isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD,
            userId: userId ?? undefined
        }));
        $[9] = cloudId;
        $[10] = contentId;
        $[11] = contentType;
        $[12] = excerpt;
        $[13] = isEndOfPage;
        $[14] = onLoadComplete;
        $[15] = userId;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null);
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1R1bQ.SocialProof), null);
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== isEndOfPage) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            spread: "space-between",
            shouldWrap: false,
            grow: "fill",
            space: "space.200"
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.100"
        }, t10, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5BwjK.AudioPlaylistButton), {
            isEndOfPage: isEndOfPage
        })));
        $[19] = isEndOfPage;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.200",
            xcss: $9c44b8c40f625697$var$styles,
            testId: "page-card-popup-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            alignBlock: "start",
            alignInline: "start",
            grow: "fill",
            space: "space.200"
        }, t7, t8, t11));
        $[21] = t11;
        $[22] = t8;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== shouldUseAutomationDiscovery) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
            shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
        });
        $[24] = shouldUseAutomationDiscovery;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] !== handlePopupClick || $[27] !== t12 || $[28] !== t13 || $[29] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
            isHoverPageCard: true,
            onClick: handlePopupClick
        }, t5, t12, t13);
        $[26] = handlePopupClick;
        $[27] = t12;
        $[28] = t13;
        $[29] = t5;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
};
module.exports["PopupViewWithAISnippet"] = $9c44b8c40f625697$export$28f0f82c7dd8d86e;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $42omo.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]);
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default // presentation role here to tell screen readers that this is not interactive
    ), {
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $1Whri.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_4t3i1osq _1bsb1osq"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("226KS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17b1021e2b775282$var$_react = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("42omo")));

var $17b1021e2b775282$var$_baseNew = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17b1021e2b775282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17b1021e2b775282$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $17b1021e2b775282$var$_react.default.createElement($17b1021e2b775282$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$17b1021e2b775282$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $17b1021e2b775282$var$_default = module.exports.default = $17b1021e2b775282$var$AssetsSchemaIcon;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});


//# sourceMappingURL=EndOfPageRecommendation.49645aa5.js.map
